(() => {
  if (window.realImperialNavigationBound) return;
  window.realImperialNavigationBound = true;
  const selector = '.ri-mobile-menu, .ri-nav-sub';
  const sync = (menu) => menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
  const close = (menu) => {
    menu.querySelectorAll('details[open]').forEach(child => { child.open = false; sync(child); });
    menu.open = false;
    sync(menu);
  };
  const updateHeight = () => {
    const header = document.querySelector('.ri-header');
    const group = document.getElementById('header-group');
    if (!header || !group) return;
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${group.offsetHeight}px`);
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
  };
  let observer;
  const initialize = () => {
    document.querySelectorAll(selector).forEach(sync);
    updateHeight();
    observer?.disconnect();
    const group = document.getElementById('header-group');
    if (group && 'ResizeObserver' in window) {
      observer = new ResizeObserver(updateHeight);
      observer.observe(group);
    }
  };
  document.addEventListener('toggle', event => {
    if (event.target instanceof Element && event.target.matches(selector)) sync(event.target);
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.ri-mobile-menu a, .ri-nav-sub a');
    if (link) {
      const outer = link.closest('.ri-mobile-menu');
      if (outer) close(outer);
      else { const sub = link.closest('.ri-nav-sub'); if (sub) close(sub); }
    }
    document.querySelectorAll('.ri-mobile-menu[open], .ri-nav-sub[open]').forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const mobile = document.querySelector('.ri-mobile-menu[open]');
    if (mobile) { close(mobile); mobile.querySelector(':scope > summary')?.focus(); return; }
    const focused = document.activeElement?.closest('.ri-nav-sub[open]');
    document.querySelectorAll('.ri-nav-sub[open]').forEach(close);
    focused?.querySelector(':scope > summary')?.focus();
  });
  window.addEventListener('resize', () => {
    updateHeight();
    if (window.innerWidth >= 900) document.querySelectorAll('.ri-mobile-menu[open]').forEach(close);
  }, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
